import { NgClass } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'save-btn',
  standalone: true,
  imports: [TranslateModule, NgClass],
  templateUrl: './save-btn.component.html',
  styleUrl: './save-btn.component.scss',
})
export class SaveBtn {
  @Input() label: string = 'front.save-btn.save';
  @Input() disabled = false;
  @Input() borderlsess = false;
  @Input() type: 'button' | 'submit' = 'button';
  fullWidth = input<boolean>(false);
}
